import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopCandidatesComponent } from "./top-candidates.component";
import { TranslateModule } from "@ngx-translate/core";
import { BarChartRendererModule } from '../table/renderers/bar-chart-renderer/bar-chart-renderer.module';
import { TableModule } from '@valg-shared/components/table/table.module';
import { CardInformationContentModule } from '../cards/card-information-content/card-information-content.module';
import { ResultSummaryModule } from '../result-summary/result-summary.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        BarChartRendererModule,
        TableModule,
        CardInformationContentModule,
        ResultSummaryModule
    ],
  declarations: [
    TopCandidatesComponent
  ],
  exports: [
    TopCandidatesComponent
  ]
})
export class TopCandidatesModule {}
